"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rebuildArray = rebuildArray;
function updateAt(collection, index, handler) {
    const target = collection[index];
    if (!target) {
        return collection;
    }
    return [...collection.slice(0, index), handler(target), ...collection.slice(index + 1)];
}
function rebuildArray(existingArray, update, options = {}) {
    if (!update) {
        return existingArray;
    }
    if (Array.isArray(update)) {
        return update;
    }
    const { afterReorder, idSelector } = options;
    let updatedArray = existingArray;
    if (update.toAdd && !existingArray.includes(update.toAdd)) {
        updatedArray = [...existingArray, update.toAdd];
    }
    if (update.toRemove) {
        return updatedArray.filter((entry) => entry !== update.toRemove);
    }
    if (update.toRemoveById && idSelector) {
        return updatedArray.filter((entry) => idSelector(entry) !== update.toRemoveById);
    }
    if (update.toUpdateAll) {
        updatedArray = updatedArray.map((entry) => {
            if (typeof update.toUpdateAll === 'function') {
                return Object.assign({}, update.toUpdateAll(entry));
            }
            return Object.assign(Object.assign({}, entry), update.toUpdateAll);
        });
    }
    if (update.toUpdateById && idSelector) {
        const { id, update: idUpdate } = update.toUpdateById;
        const target = updatedArray.findIndex((entry) => idSelector(entry) === id);
        updatedArray = updateAt(updatedArray, target, (entry) => {
            if (typeof idUpdate === 'function') {
                return Object.assign({}, idUpdate(entry));
            }
            return Object.assign(Object.assign({}, entry), idUpdate);
        });
    }
    if (update.toReorderByIndex) {
        const { sourceIndex, targetIndex } = update.toReorderByIndex;
        if (sourceIndex > -1 && targetIndex > -1) {
            const entry = updatedArray[sourceIndex];
            if (entry) {
                updatedArray = [...updatedArray.slice(0, sourceIndex), ...updatedArray.slice(sourceIndex + 1)];
                updatedArray.splice(targetIndex, 0, entry);
                if (afterReorder) {
                    updatedArray = updatedArray.map(afterReorder);
                }
            }
        }
    }
    return updatedArray;
}
//# sourceMappingURL=rebuildArray.js.map